import React from 'react';
import SpecialOffersBelowTheFold from '@hpstellar/pdp/SpecialOffersBelowTheFold';

import PDPSection from '../pdp-section';
import withPageComponents from '../../../page/components/with-page-components';
import { Grid, Column } from '../../../ui/components/grid';


const pdpGallery = ({ pdpSpecialOffers }) => {
    if (pdpSpecialOffers) {
        const { title, offers } = pdpSpecialOffers;
        return (<section id="offers">
            <SpecialOffersBelowTheFold
                title={title}
                offers={offers} />
        </section>);
    }
    return null;
}

export default withPageComponents(pdpGallery, { components: ['pdpSpecialOffers'] })
